import React from 'react';
import { Modal, Paper, Grid, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import './ModalWrapper.css';

const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
});

const ModalWrapper = (props) => {
    const classes = useStyles();
    const { open, height, hideBackdrop, allowClickOutsideToClose, onCloseClicked, constraintsRef, overflowInitial } = props;

    const modalWrapperProps = {
        open: open,
        hideBackdrop: hideBackdrop,
        ...(allowClickOutsideToClose && { onClose: onCloseClicked }),
    };

    let size = '';

    switch (height) {
        case 'small':
            size = '--small';
            break;
        case 'large':
            size = '--large';
            break;

        default:
            break;
    }

    return (
        <Modal {...modalWrapperProps} className='modal'>
            <Paper elevation={2} className={`modal-wrapper${size} ${overflowInitial ? 'overflow-initial' : ''}`}>
                <Grid container className='modal-wrapper-grid' ref={constraintsRef}>
                    <Grid container item justifyContent='flex-end' alignContent='flex-end' className='modal-wrapper-close-bar'>
                        {onCloseClicked && (
                            <IconButton
                                aria-label='delete'
                                onClick={onCloseClicked}
                                disableRipple={true}
                                disableTouchRipple={true}
                                classes={{ root: classes.root }}
                            >
                                <CloseIcon />
                            </IconButton>
                        )}
                    </Grid>
                    <Grid container item className={`modal-wrapper-form-container${size}`}>
                        {props.children}
                    </Grid>
                </Grid>
            </Paper>
        </Modal>
    );
};

ModalWrapper.defaultProps = {
    height: 'normal',
};

export default ModalWrapper;
